import { toast } from 'react-toastify';
import { MASTER_SETTING } from '../config/apiEndPoint';
import { GET, POST, PUT } from 'config/api.config';

export const getOverrideMasterSettings = async (data = {}) => {
    try {
        const response = await GET(MASTER_SETTING.GET_OVERRIDE_MASTER_SETTINGS, data);
        return response;
    } catch (error) {
        toast.error(error?.message);
    }
};

export const updateOverrideMasterSettings = async (data = {}) => {
    try {
        const response = await PUT(MASTER_SETTING.UPDATE_OVERRIDE_MASTER_SETTINGS, data);
        return response;
    } catch (error) {
        toast.error(error?.message);
    }
};

/** POST `Settings/test-email` */
export const submitTestEmail = async (data = {}) => {
    try {
        const response = await POST(MASTER_SETTING.TEST_EMAIL, data);
        return response;
    } catch (error) {
        toast.error(error?.message);
    }
};
